import { ConnectorType, LockSeamType } from "./joint";

export default class MachineSettings {
    /** Male bend target angle, in degrees */
    maleBendTarget = 90;
    /** Corner bend target angle, in degrees */
    cornerBendTarget = 89;
    /** Lock seam settings, per LockSeamType */
    lockSeamSettings = LockSeamSettings.default;
    /** Notch depth settings, per ConnectorType */
    notchDepthSettings = NotchDepthSettings.default;
}

export class LockSeamSetting {
    /** Lock Seam Type */
    type: LockSeamType;
    /** Male Lock Seam Length (inches) */
    maleLength: number;
    /** Female Lock Seam Length (inches) */
    femaleLength: number;
    /** Bend the male lock seam? */
    bendMale: boolean;

    constructor(type: LockSeamType, maleLength: number, femaleLength: number, bendMale: boolean) {
        this.type = type;
        this.maleLength = maleLength;
        this.femaleLength = femaleLength;
        this.bendMale = bendMale;
    }

    static zero(type: LockSeamType) {
        return new LockSeamSetting(type, 0, 0, false);
    }
}

export class LockSeamSettings {
    readonly settings: ReadonlyMap<LockSeamType, LockSeamSetting>;

    constructor(...settings: readonly LockSeamSetting[]) {
        this.settings = new Map(settings.map(s => [s.type, s]));
    }

    get(type: LockSeamType) {
        return this.settings.get(type) || LockSeamSetting.zero(type);
    }

    map<U>(callbackfn: (value: LockSeamSetting, index: number, array: readonly LockSeamSetting[]) => U) {
        return Array.from(this.settings.values()).map(callbackfn);
    }

    static readonly default = new LockSeamSettings(
        new LockSeamSetting(LockSeamType.LargePittsburgh, 7 / 16, 1 + 5 / 16, true),
        new LockSeamSetting(LockSeamType.SmallPittsburgh, 1 / 4, 15 / 16, true),
        new LockSeamSetting(LockSeamType.Snap, 7 / 16, 1 + 5 / 16, true),
    );
}

export class NotchDepthSetting {
    /** Connector Type */
    public type: ConnectorType;
    /** Lead and Trail Notch Depth (inches) */
    public ltDepth: number;
    /** Vee Notch Depth (inches) */
    public veeDepth: number;

    constructor(type: ConnectorType, ltDepth: number, veeDepth: number) {
        this.type = type;
        this.ltDepth = ltDepth;
        this.veeDepth = veeDepth;
    }

    static zero(type: ConnectorType) {
        return new NotchDepthSetting(type, 0, 0);
    }
}

export class NotchDepthSettings {
    readonly settings: ReadonlyMap<ConnectorType, NotchDepthSetting>;

    constructor(...settings: readonly NotchDepthSetting[]) {
        this.settings = new Map(settings.map(s => [s.type, s]));
    }

    get(type: ConnectorType) {
        return this.settings.get(type) || NotchDepthSetting.zero(type);
    }

    map<U>(callbackfn: (value: NotchDepthSetting, index: number, array: readonly NotchDepthSetting[]) => U) {
        return Array.from(this.settings.values()).map(callbackfn);
    }

    static readonly default = new NotchDepthSettings(
        new NotchDepthSetting(ConnectorType.SandD, 1 / 2, 1 / 2),
        new NotchDepthSetting(ConnectorType.TD, 2 + 3 / 8, 1 + 7 / 8),
        new NotchDepthSetting(ConnectorType.SlipRaw, 1 / 2, 1 / 2),
        new NotchDepthSetting(ConnectorType.SlipFemale, 1 + 1 / 2, 1 + 1 / 2),
    );
}
